import { Checkbox, FormControlLabel, Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { CommonSearch } from 'shell/view-models/search-anpr';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface NationalSearch {
  isNationalResearch?: boolean;
  provinceOfResidence?: string;
  municipalityOfResidence?: MunicipalityAnprVM | null;
  errorMunicipalityOfResidence?: FormikErrors<MunicipalityAnprVM>;
  touchedMunicipalityOfResidence?: FormikTouched<MunicipalityAnprVM>;
  onChange: (key: keyof CommonSearch, value: CommonSearch[keyof CommonSearch]) => void;
  onChangeValues: (object: CommonSearch) => void;
  isOnlyNationalSearch?: boolean;
}

const NationalCommonSearch = ({
  isNationalResearch,
  // provinceOfResidence,
  municipalityOfResidence,
  errorMunicipalityOfResidence,
  touchedMunicipalityOfResidence,
  onChange,
  onChangeValues,
  isOnlyNationalSearch,
}: NationalSearch): React.ReactElement => {
  const { userProfile } = useUserProfile();

  // const operatorAuthorizations = useOperatorAuthorization(personAuths);

  // const params: MunicipalityParams = useMemo(() => {
  //   return {
  //     province: provinceOfResidence || '',
  //   };
  // }, [provinceOfResidence]);

  // const onChangeProvince = useEventCallback((province: string) => {
  //   onChange('provinceOfResidence', event.target.value);
  // });

  const onChangeMunicipality = useEventCallback((municipality: MunicipalityAnprVM | null) =>
    onChange('municipalityOfResidence', municipality)
  );

  return (
    <Grid item container spacing={2} alignItems="center" marginBottom={2}>
      {userProfile.datiLogin?.profile?.feature?.anpr === '0' ||
      userProfile.datiLogin?.profile?.feature?.anpr === '1' ? undefined : (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                id="isNationalResearch"
                name="isNationalResearch"
                checked={isNationalResearch || false}
                onChange={() =>
                  onChangeValues({
                    isNationalResearch: !isNationalResearch,
                    municipalityOfResidence: !isNationalResearch
                      ? null
                      : {
                          id: userProfile.datiLogin?.codiceIstat,
                          description: userProfile.datiLogin?.nomeComune || '',
                          province: userProfile.datiLogin?.siglaProvincia || '',
                        },
                  })
                }
                inputProps={{ 'aria-label': 'ricerca nazionale' }}
              />
            }
            label="Ricerca nazionale"
            disabled={isOnlyNationalSearch}
          />
        </Grid>
      )}
      {/* <Grid item xs={12} md={5}>
        <ProvinceList
          value={provinceOfResidence || ''}
          onChange={onChangeProvince}
          disabled={!isNationalResearch}
          label="Provincia di residenza"
          id="provinceOfResidence"
          onBootstrap={isNationalResearch}
        />
      </Grid> */}
      <Grid item xs={12} md={5}>
        <MunicipalityList
          value={municipalityOfResidence || null}
          onChange={onChangeMunicipality}
          disabled={isNationalResearch || userProfile.datiLogin?.profile?.feature?.anpr === '1'}
          label="Comune di residenza"
          id="municipalityOfResidence"
          error={touchedMunicipalityOfResidence && Boolean(errorMunicipalityOfResidence)}
          // params={params}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia di residenza"
          label="Provincia di residenza"
          id="provinceOfResidence"
          name="provinceOfResidence"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={municipalityOfResidence?.province || ''}
          // onChange={onChangeProvince}
        />
      </Grid>
    </Grid>
  );
};

NationalCommonSearch.displayName = 'Filters Person section National Research component';

const NationalSearch = memo(NationalCommonSearch);

export default NationalSearch;
